import { render } from "./LessonVideoPresentation.vue?vue&type=template&id=8f721f30"
import script from "./LessonVideoPresentation.vue?vue&type=script&lang=js"
export * from "./LessonVideoPresentation.vue?vue&type=script&lang=js"

import exportComponent from "F:\\-=Projects=-\\Sites\\map\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__